import { render } from "./AsSeenIn.vue?vue&type=template&id=7fca71a5&scoped=true"
import script from "./AsSeenIn.vue?vue&type=script&lang=js"
export * from "./AsSeenIn.vue?vue&type=script&lang=js"

import "./AsSeenIn.vue?vue&type=style&index=0&id=7fca71a5&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fca71a5"]])

export default __exports__